// extracted by css-extract-rspack-plugin
export default {"root":"root-A9DF09"};